document.addEventListener("DOMContentLoaded", function () {

    document.querySelectorAll(".customer-review-carousel").forEach(function(section){

        const slider = section.querySelector(".crc-slider");
        const cards = slider.querySelectorAll(".crc-card");
        const dots = section.querySelectorAll(".crc-dots span");

        if(cards.length <= 1) return;

        let visible = 5;

        function updateVisible(){
            if(window.innerWidth <= 768){
                visible = 1;
            }else if(window.innerWidth <= 1200){
                visible = 3;
            }else{
                visible = 5;
            }
        }

        updateVisible();

        window.addEventListener("resize", updateVisible);

        let index = 0;

        function slide(){

            updateVisible();

            const card = cards[0];
            const gap = 30;

            let width = card.offsetWidth + gap;

            if(window.innerWidth <= 768){
                width = card.offsetWidth + 18;
            }

            slider.style.transform = "translateX(-" + (index * width) + "px)";

            if(dots.length){

                dots.forEach(function(dot){
                    dot.classList.remove("active");
                });

                dots[index % dots.length].classList.add("active");

            }

            index++;

            if(index > cards.length - visible){

                setTimeout(function(){

                    slider.style.transition = "none";
                    slider.style.transform = "translateX(0px)";
                    index = 0;

                    setTimeout(function(){
                        slider.style.transition = ".55s ease";
                    },50);

                },550);

            }

        }

        slider.style.transition = ".55s ease";

        setInterval(slide,6000);

    });

});